import { LEGAL_DOCS } from '@/features/legal';
import type { ConsentItem } from '@/shared/types/auth.type';
import type { AgreementValues } from '../types/agreement-step.type';

/**
 * 동의 화면 체크 상태 → 서버 제출 줄.
 *
 * 판은 화면이 보여준 txt 의 판(`LEGAL_DOCS[*].version`)이다 — 서버가 판을 정하면 구판 본문을 띄운 채
 * 신판 동의가 기록될 수 있다. 마케팅·이벤트는 판 관리 대상이 아니라 이용약관 판을 함께 보낸다.
 * 선택 항목은 거부(false)도 보낸다 — 서버가 거부 이력도 남긴다.
 */
export function consentItemsFrom(values: AgreementValues): ConsentItem[] {
  return [
    {
      document: 'TERMS',
      version: LEGAL_DOCS.terms.version,
      agreed: values.agreeTerms,
    },
    {
      document: 'PRIVACY',
      version: LEGAL_DOCS.privacy.version,
      agreed: values.agreePrivacy,
    },
    {
      document: 'MARKETING',
      version: LEGAL_DOCS.terms.version,
      agreed: values.agreeMarketing,
    },
    {
      document: 'EVENT',
      version: LEGAL_DOCS.terms.version,
      agreed: values.agreeEvent,
    },
  ];
}

/** 가입 요청에 실을 필수 문서 판 — 사용자가 가입 화면에서 읽은 판. */
export const signupLegalVersions = () => ({
  termsVersion: LEGAL_DOCS.terms.version,
  privacyVersion: LEGAL_DOCS.privacy.version,
});

export const EMPTY_AGREEMENTS: AgreementValues = {
  agreeTerms: false,
  agreePrivacy: false,
  agreeMarketing: false,
  agreeEvent: false,
};
